// extracted by mini-css-extract-plugin
module.exports = {"billed-label":"BilledStatusColumn_billed-label__3W7Z4"};